<div class="tool-content-container">
  <div class="tool-description">
    Enter a student ID, select a
    <instruction-step-link
      link="target-course"
      text="Target Course"
      appendedText="(That's not already on the taken courses list)"
    />, and click submit to generate results for course grade estimation.
    <!-- <b class="instructions-title"
      >To generate results for course grade estimation:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Enter a
    <instruction-step-link
      link="student-id"
      text="Student ID"
      appendedText="(Relevant form fields will be pre-populated)"
    />
    <br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="target-semester" text="Target Semester" />
    <br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link
      link="target-course"
      text="Target Course"
      appendedText="(That's not already on the taken courses list)"
    />
    <br />
    Step 4 <i class="fa-solid fa-arrow-right"></i> Click on the submit button<br /><br /> -->
    <br /><br />
    <b class="important-note">
      *Additional courses can be added to taken courses by selecting a course
      number and course grade.<br /><br />
    </b>

    <b class="warning-note">
      *Results are shown as an estimated upper and lower grade range, or in the
      case that a range cannot be obtained, the historical probability of
      passing is shown.<br />
      *Course grade estimation tool only works from cohort 2020 and later.</b
    >
  </div>

  <div class="table-container" *ngIf="!!dataSource.length && !mobileView">
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z8"
      multiTemplateDataRows
    >
      <ng-container matColumnDef="method">
        <th mat-header-cell *matHeaderCellDef>Method</th>
        <td mat-cell *matCellDef="let element">{{ element.method }}</td>
      </ng-container>

      <ng-container matColumnDef="target_course">
        <th mat-header-cell *matHeaderCellDef>Target Course</th>
        <td mat-cell *matCellDef="let element">{{ element.target_course }}</td>
      </ng-container>

      <ng-container matColumnDef="taken_courses">
        <th mat-header-cell *matHeaderCellDef>Taken Courses</th>
        <td mat-cell *matCellDef="let element">{{ element.taken_courses }}</td>
      </ng-container>

      <ng-container matColumnDef="lower_range">
        <th mat-header-cell *matHeaderCellDef>Lower Range</th>
        <td mat-cell *matCellDef="let element">
          {{ element.lower_range || 'NA' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="upper_range">
        <th mat-header-cell *matHeaderCellDef>Upper Range</th>
        <td mat-cell *matCellDef="let element">
          {{ element.upper_range || 'NA' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="prob_pass">
        <th mat-header-cell *matHeaderCellDef>Passing Probability</th>
        <td mat-cell *matCellDef="let element">
          {{ element.upper_range ? 'NA' : element.prob_pass }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let row">
          <a mat-icon-button (click)="deleteRow($event, row)">
            <mat-icon aria-hidden="false" aria-label="Delete"
              >delete_forever</mat-icon
            >
          </a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-- Mobile View -->
  <div *ngIf="dataSource.length && mobileView">
    <mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z8 table-container"
    >
      <!-- Method Row -->
      <ng-container matColumnDef="method">
        <mat-header-cell *matHeaderCellDef>Method</mat-header-cell>
        <mat-cell *matCellDef="let element"
          ><span>Method:</span> {{ element.method }}</mat-cell
        >
      </ng-container>

      <!-- Target Course Row -->
      <ng-container matColumnDef="target_course">
        <mat-header-cell *matHeaderCellDef>Target Course</mat-header-cell>
        <mat-cell *matCellDef="let element"
          ><span>Target Course:</span> {{ element.target_course }}</mat-cell
        >
      </ng-container>

      <!-- Taken Course Row -->
      <ng-container matColumnDef="taken_courses">
        <mat-header-cell *matHeaderCellDef>Taken Courses</mat-header-cell>
        <mat-cell *matCellDef="let element"
          ><span>Taken Courses:</span> {{ element.taken_courses }}</mat-cell
        >
      </ng-container>

      <!-- Lower Range Row -->
      <ng-container matColumnDef="lower_range">
        <mat-header-cell *matHeaderCellDef>Lower Range</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>Lower Range:</span> {{ element.lower_range || 'NA' }}
        </mat-cell>
      </ng-container>

      <!-- Upper Range Row -->
      <ng-container matColumnDef="upper_range">
        <mat-header-cell *matHeaderCellDef>Upper Range</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>Upper Range:</span> {{ element.upper_range || 'NA' }}
        </mat-cell>
      </ng-container>

      <!-- Probability Pass Row -->
      <ng-container matColumnDef="prob_pass">
        <mat-header-cell *matHeaderCellDef>Passing Probability</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>Passing Probability:</span>
          {{ element.upper_range ? 'NA' : element.prob_pass }}
        </mat-cell>
      </ng-container>

      <!-- Action Row -->
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span>Action:</span>
          <a mat-icon-button (click)="deleteRow($event, row)">
            <mat-icon aria-hidden="false" aria-label="Delete"
              >delete_forever</mat-icon
            >
          </a>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>

  <back-button></back-button>
</div>
